module.exports = __webpack_public_path__ + "../resources/images/showDeletedLarge-f8b0a39cdea282f51c3132412561fb90.svg";